import React, { Component, PropTypes } from 'react';

import S from './style.css';

export default class StatusEdit extends Component {
  static propTypes = {
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
  }

  state = {
    newText: null,
  }

  handleChange = ({ target: { value } }) => {
    this.setState({
      newText: value
    });
  }

  handleSave = () => {
    const { newText } = this.state;
    if (newText) {
      this.props.onSave(newText);
    } else {
      this.props.onCancel();
    }
  }

  render() {
    const { onCancel, text } = this.props;
    const { newText } = this.state;

    const buttonClasses =
      `${S.button} bn bg-transparent pa2 br2 cursor-pointer outline-0`;
    const finalText = newText === null ? text : newText;

    return (
      <div>
        <textarea
          autoFocus
          className="db w-100 h4 app-b--blue br2 pa2 f5"
          onChange={this.handleChange}
          value={finalText}
        />
        <div className="tr mt2 mb2">
          <button
            className={`${buttonClasses} app-bg-light-blue`}
            onClick={onCancel}
          >
            CANCEL
          </button>
          <button
            className={`${buttonClasses} app-bg-blue white ml2`}
            disabled={!finalText}
            onClick={this.handleSave}
          >
            SAVE
          </button>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/containers/StatusEdit/index.jsx
 **/